var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "uni-caculate-wrapper" }, [
      _c("div", { staticClass: "hide", attrs: { id: "op-history-container" } }),
      _c("div", { staticClass: "inputs-wrapper" }, [
        _c("input", { attrs: { type: "text", id: "input-top" } }),
        _c("input", {
          attrs: { type: "text", id: "input-bottom", placeholder: "0" },
        }),
      ]),
      _c("div", { staticClass: "gradient-divider" }),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "num", attrs: { "data-set": "7" } }, [
          _vm._v("7"),
        ]),
        _c("div", { staticClass: "num", attrs: { "data-set": "8" } }, [
          _vm._v("8"),
        ]),
        _c("div", { staticClass: "num", attrs: { "data-set": "9" } }, [
          _vm._v("9"),
        ]),
        _c("div", { staticClass: "op", attrs: { "data-set": "/" } }, [
          _vm._v("÷"),
        ]),
      ]),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "num", attrs: { "data-set": "4" } }, [
          _vm._v("4"),
        ]),
        _c("div", { staticClass: "num", attrs: { "data-set": "5" } }, [
          _vm._v("5"),
        ]),
        _c("div", { staticClass: "num", attrs: { "data-set": "6" } }, [
          _vm._v("6"),
        ]),
        _c("div", { staticClass: "op", attrs: { "data-set": "*" } }, [
          _vm._v("x"),
        ]),
      ]),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "num", attrs: { "data-set": "1" } }, [
          _vm._v("1"),
        ]),
        _c("div", { staticClass: "num", attrs: { "data-set": "2" } }, [
          _vm._v("2"),
        ]),
        _c("div", { staticClass: "num", attrs: { "data-set": "3" } }, [
          _vm._v("3"),
        ]),
        _c("div", { staticClass: "op", attrs: { "data-set": "-" } }, [
          _vm._v("-"),
        ]),
      ]),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "num", attrs: { id: "reset" } }, [
          _vm._v("C"),
        ]),
        _c("div", { staticClass: "num", attrs: { "data-set": "0" } }, [
          _vm._v("0"),
        ]),
        _c("div", { staticClass: "num", attrs: { "data-set": "." } }, [
          _vm._v("."),
        ]),
        _c("div", { staticClass: "op", attrs: { "data-set": "+" } }, [
          _vm._v("+"),
        ]),
      ]),
      _c("div", { attrs: { id: "equal", "data-set": "=" } }, [_vm._v("=")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }